export default __webpack_public_path__ + "static/media/icon-security.2b05160b.svg";